/*归属查询
i:get || post
h:requestGet ||requestPost
*/
import axios from '../../axios'
export default {
    getAttributionList: (data) => {//列表
        return axios.get('/api/api/agent/invite/user',data);
    },
}